import { defineMessages } from 'react-intl';
export default defineMessages({
    allFavorites: {
        id: 'navigation.allFavorites',
        defaultMessage: 'See all'
    },
    breadcrumbs: {
        id: 'navigation.breadcrumbs',
        defaultMessage: 'Breadcrumb'
    },
    collapseNavigation: {
        id: 'navigation.collapseNavigation',
        defaultMessage: 'Collapse navigation'
    },
    expandNavigation: {
        id: 'navigation.expandNavigation',
        defaultMessage: 'Expand navigation'
    },
    main: {
        id: 'navigation.main',
        defaultMessage: 'Main'
    },
    stationsShort: {
        id: 'navigation.stationsShort',
        defaultMessage: 'Stations'
    },
    mapShort: {
        id: 'navigation.mapShort',
        defaultMessage: 'Map'
    },
    skipToContent: {
        id: 'navigation.skipToContent',
        defaultMessage: 'Skip to main content'
    }
});
